import { getAppReferrer } from './sessionStorageManager'

export const isTwaApp = () => {
  if (typeof sessionStorage === 'undefined') return false
  return document.referrer.includes('android-app') || getAppReferrer() === 'twa'
}
